module.exports = __webpack_public_path__ + "img/baidupan.e09c99fe.svg";